import { useEffect, useState } from "react";
import Sign from './Sign';

function Loading({ fetched }) {
    const [count, setCount] = useState(0);

    useEffect(() => {
        const timer = setInterval(() => {
            setCount(current => current + 1);
        }, 500);

        return () => {
            clearInterval(timer);
        };
    }, []);

    const dotCount = count % 4;
    const dots = ".".repeat(dotCount);

    return (
        <div style={{
            fontSize: "14px",
            display: "flex",
            alignItems: "center",
            gap: "5px",
            width: "118px",
        }}>
            <Sign fetched={fetched} />
            {fetched ?
                <div>안테나 연결 완료</div> :
                <div>안테나 연결 중{dots}</div>
            }
        </div>
    );
}

export default Loading;